<template>
  <v-card
    class="barcode-dialog"
  >
    <v-card-title class="barcode-dialog__close pa-0">
      <v-btn
        icon
      >
        <v-icon
          small
          @click="$emit('close-camera')"
        >
          close
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text
      class="pa-0 barcode-dialog__video"
    >
      <Loader
        v-if="isLoading"
        class="mt-5 mb-5"
      />
      <div
        v-show="!isLoading"
        id="barcode-scanner"
        class="barcode"
      >
        <canvas
          class="drawingBuffer custom-canvas"
          width="640"
          height="480"
        />
      </div>
    </v-card-text>
    <div class="overlay">
      <div class="anim-box">
        <div />
        <div
          v-show="!isLoading"
          class="scanner"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import Quagga from 'quagga';
import { mapGetters } from 'vuex';
import { EventBus } from '@/event-bus.js';
import Loader from '@/components/Loader.vue';

export default defineComponent({
  components: {
    Loader,
  },

  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isLoading: true,
    };
  },

  computed: {
    ...mapGetters(['getCustomer']),
  },

  mounted() {
    this.initQuagga();

    Quagga.onDetected(this.handleBarcodeDetection);
  },

  methods: {
    initQuagga() {
      Quagga.init({
        inputStream: {
          name: 'Live',
          type: 'LiveStream',
          target: document.querySelector('#barcode-scanner'), // ID do elemento onde o leitor de código de barras será renderizado,
          constraints: {
            facingMode: 'environment',
            aspectRatio: {
              min: 1,
              max: 2,
            },
          },
        },
        locate: true,
        locator: {
          halfSample: true,
          patchSize: 'medium',
        },
        numOfWorkers: 2,

        decoder: {
          readers: ['ean_reader', 'code_128_reader', 'code_39_reader'], // Lista de tipos de código de barras que você deseja ler
        },
      }, (err) => {
        if (err) {
          console.error(err);
          return;
        }

        Quagga.start();

        const track = Quagga.CameraAccess.getActiveTrack();
        const capabilities = track.getCapabilities();

        if (capabilities.zoom) {
          track.applyConstraints({ advanced: [{ zoom: 3 }] });
        }

        // eslint-disable-next-line no-return-assign
        setTimeout(() => this.isLoading = false, 300);
      });
    },

    handleBarcodeDetection(result) {
      console.log('result:', result);
      let findProduct;
      this.products.forEach((product) => {
        if (!findProduct) {
          const existEan = product.skus.find((sku) => sku.ean === result.codeResult.code);
          if (existEan) findProduct = product;
        }
      });

      if (findProduct) {
        this.redirectToProductPage(findProduct);
      } else {
        this.emitSnackBar();
        this.$emit('close-camera');
      }

      Quagga.stop();
    },

    redirectToProductPage(product) {
      const query = {};
      if (this.getCustomer.salesAssistant) query.skuId = product.skus[0].sku_id;

      this.$router.replace({
        name: 'detalhamento de produtos',
        params: { id: product.id },
        query,
      });
    },

    emitSnackBar() {
      const snackBar = {};
      snackBar.text = 'Produto não encontrado.';
      snackBar.value = true;
      EventBus.$emit('activeSnackBar', snackBar);
    },
  },

});
</script>

<style scoped lang="scss">
.overlay {
  position: absolute;
  top: 200px;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  pointer-events: none;
}

.barcode .custom-canvas {
  height: 0 !important;
}

.barcode-dialog {
  padding: 0px 20px 40px 20px;
  text-transform: none;
  border-radius: 7px;
  color: #140C22;
  box-sizing: border-box;
  overflow: hidden;
  &__close {
    display: flex;
    justify-content: end;
    transform: translateX(15px);
  }
  &__video {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

/* barcode container */
.anim-box {
  position: absolute;
  width: 300px;
  height: 150px;
  padding: 25px 30px;
  transition: transform .6s ease-out;
  margin-bottom: 420px;
  z-index: 2;
}

/* adds the 4 corners */
.anim-box:before, .anim-box:after, .anim-box>:first-child:before, .anim-box>:first-child:after {
  position: absolute;
  width: 10%; height: 15%;
  border-color: white;
  border-style: solid;
  content: ' ';
}

/* top left corner */
.anim-box:before {
  top: 0; left: 0;
  border-width: 2px 0 0 2px;
}

/* top right corner */
.anim-box:after {
  top: 0; right: 0;
  border-width: 2px 2px 0 0;
}

/* bottom right corner */
.anim-box>:first-child:before {
  bottom: 0; right: 0;
  border-width: 0 2px 2px 0;
}

/* bottom left corner */
.anim-box>:first-child:after {
  bottom: 0; left: 0;
  border-width: 0 0 2px 2px;
}

.anim-box:hover .scanner {
  animation-play-state: running;
}

/* laser beam */
.scanner {
  width: 100%;
  height: 3px;
  background-color: red;
  opacity: 0.7;
  position:relative;
  box-shadow: 0px 0px 8px 10px rgba(170, 11, 23, 0.49);
  top:50%;
}

</style>
